export const Z_INDEXES = {
  DROPDOWN: 3,
  HEADER: 2,
};
